import React from 'react';
import Overleaf from './apps/overleaf';
import { createTheme, ThemeProvider } from "@vitalsource/vstui/themes";
import setTitle from './utils/set-title';
import Dispatcher from './dispatcher';
import { addParameter } from "./ui/utils/location";
import { getBookshelfRoot } from './utils/bookshelf-root';

var BookshelfController = {

  // Handle things that need to be called on every page.
  _setup: function(options){
    if (options && options.locale){
      i18n.changeLocale(options.locale, () => {});
      Fraction.Helpers.setItem('updateLanguageOnLogin', options.locale);
    }
    options = options || {};
    Fraction.initialCFI = undefined;
    Fraction.assignmentCreator = false;
    $(window).unbind();
    $('a').unbind();
    document.title = setTitle(Fraction.Brand)
    $(".favicon").remove();
    var link = document.createElement('link');
    link.type = 'image/png';
    link.rel = 'shortcut icon';

    // If `brand` param is present, we're in branding tool preview so omit the
    // protocal and location host.
    var param_brand = Fraction.Helpers.getParameterByName('brand');
    if (param_brand.length>0){
      link.href = Fraction.Brand.Graphics.favicon;
    } else {
      if (Fraction.Helpers.isRelativeURL(Fraction.Brand.Graphics.favicon)){
        link.href = document.location.protocol+"//"+document.location.host+Fraction.Brand.Graphics.favicon;
      } else {
        link.href = Fraction.Brand.Graphics.favicon;
      }
    }

    // Custom class added to HTML and body elements
    // Only for the rare exceptions to branded instances that have features
    // outside normal customization options
    if (Fraction.Brand && Fraction.Brand.Graphics && Fraction.Brand.Graphics.background) {
      $("html").addClass("cover-background");

      $("html").css("background-image", "url('" + Fraction.Brand.Graphics.background + "')");

    }

    document.getElementsByTagName('head')[0].appendChild(link);
    if (!options.skipAuth){
      Fraction.Helpers.getUser(function(){
        if (Fraction.User){
          BookshelfController._updateNewLocale();
          try {
            //BookshelfController._captureFingerprint();
          } catch (e) {}
          if (BookshelfController._checkVerify()){
            return;
          }
          if (BookshelfController._checkSSO()){
            return;
          }
          try {
            Fraction.Helpers.ifPhony();
          } catch (e) {}
        }
      });
    }
    $('body').attr('data-theme-base', Fraction.Brand.Theme.base);
    $('body').attr('data-theme-primary', Fraction.Brand.Theme.primary);
    $('body').attr('data-theme-secondary', Fraction.Brand.Theme.secondary);
  },

  _wrapTheme: function(component) {
    const colors = window.brands.getPaletteColors();
    const theme = {
      ...createTheme({
        breakpoint: {
          xs: "(min-width: 480px)"
        },
        color: {
          primary: colors[1],
          secondary: colors[2]
        },
        size: {
          large: 44,
          medium: 32,
          small: 28
        },
        typography: {
          htmlFontSize: 10
        }
      }),
      color: {
        base: colors[0],
        primary: colors[1],
        secondary: colors[2]
      }
    };
    return <ThemeProvider theme={theme}>
      {component}
    </ThemeProvider>;
  },

  // update user to a new locale, assume Fraction.User exists
  _updateNewLocale: function(){
    var newlocale = Fraction.Helpers.getItem('updateLanguageOnLogin');
    if (newlocale && newlocale !== "false"){
      Fraction.Helpers.setUserInfo({email: Fraction.User.email, locale: newlocale}, function(response){
        if (response.isSuccess()){
          Fraction.Helpers.getUser(() => {
            Fraction.Helpers.changeLocale(Fraction.User.locale);
            Fraction.Helpers.removeItem('updateLanguageOnLogin');
          }, {refresh: true});
        } else {
          if (response.message==="Unauthorized"){
            Fraction.Helpers.signin();
          } else {
            Fraction.Helpers.removeItem('updateLanguageOnLogin');
          }
        }
      });
    }
  },

  _captureFingerprint: function(){
    const lastSessionId = Fraction.Helpers.getUserData("lastSessionId");
    if (lastSessionId !== Fraction.User.sessionId) {
      Fraction.Helpers.saveUserData('lastSessionId', Fraction.User.sessionId);
      Fraction.Helpers.Fingerprint.emmitEvent();
    }
  },

  _checkVerify: function () {
    if (Fraction.User && Fraction.User.emailVerificationRequired &&
      !Fraction.User.emailVerificationCompleted && Fraction.Brand.EmailVerification.enabled) {
      Fraction.Helpers.storeAndRedirect('/verify');
      return true;
    }
    return false;
  },

  // checks SSO settings and if the user needs to finish their account, assume Fraction.User exists
  // Need to add logic around how this is remembered and when and why
  _checkSSO: function(){
    var userData = Fraction.Helpers.userData();
    if (Fraction.User && Fraction.User.ssoOnly &&
        Fraction.Router.getRoute()[0]!=="/home/eula" &&
        Fraction.Router.getRoute()[0]!=="terms" &&
        Fraction.Router.getRoute()[0]!=="user" &&
        (Fraction.Brand.AccountCompletion.force ||
         (Fraction.Brand.AccountCompletion.enabled &&
          !Fraction.Brand.AccountCompletion.ssoOnly &&
          !Fraction.Helpers.ssoSkipped &&
          (!userData.ssoTimeout ||
           !userData.lastEmailHash ||
           userData.lastEmailHash !== Fraction.User.email.hashMe() ||
           Date.now()>=parseInt(userData.ssoTimeout, 10)))
       )){
       Fraction.Helpers.storeAndRedirect('/user/sso');
       return true;
    }
    return false;
  },

  index: function(assignmentCreatorOpen){
    var staticSearchOnOpen = false;
    if (this.query && (this.query.search || this.query.q)){
      staticSearchOnOpen = this.query.search || this.query.q;
      staticSearchOnOpen = decodeURI(staticSearchOnOpen);
    }

    BookshelfController._setup();
    document.title += ": "+i18n.t('main-menu.library');
    getBookshelfRoot().render(
      BookshelfController._wrapTheme(
        <Fraction.Library
          searchOnOpen={staticSearchOnOpen}
          assignmentCreatorOpen={assignmentCreatorOpen}
          unavailableIsbn={this.query && this.query.unavailable}
        />
      )
    );
  },

  redirectIfSubscription(isbn) {
    return new Promise((resolve) => {
      Jigsaw.getBookInfo(isbn, response => {
        if (response.isSuccess() && response.data.kind === "subscription") {
          Fraction.Router.setRoute(`/explore/${isbn}`);
          return resolve(true);
        }
        return resolve(false);
      });
    })
  },

  redirectToAlternateReader(isbn, initialCFI, url, page) {
    if (!Fraction.Brand.Supernova.enabled && !Fraction.Brand.Watson.enabled) {
      return false;
    }

    let pathToUse = "";
    if (url) {
      pathToUse = url;
    } else if (initialCFI) {
      pathToUse = `/books/${isbn}/cfi/${initialCFI}`
    } else if (page) {
      pathToUse = `/books/${isbn}/page/${page}`
    } else {
      pathToUse = `/books/${isbn}`
    }
    if (this.query) {
      if (this.query.search) {
        pathToUse = addParameter(pathToUse, "search", this.query.search);
      }
      if (this.query.q) {
        pathToUse = addParameter(pathToUse, "q", this.query.q);
      }
    }
    // Watson overrides Supernova
    const prefix = Fraction.Brand.Watson.enabled ? Fraction.Brand.Watson.url : "/reader"
    window.location.replace(`${prefix}${pathToUse}`);
    return true;
  },

  show: async function(isbn, initialCFI, url, page, searchOnOpen, chromeProps){
    const didRedirect = await BookshelfController.redirectIfSubscription(isbn);
    if (didRedirect) {
      // Don't keep doing stuff
      return;
    }

    if (!chromeProps) {
      if (BookshelfController.redirectToAlternateReader.call(this, isbn, initialCFI, url, page)) {
        return;
      }
    }

    var staticSearchOnOpen = searchOnOpen;
    if (this.query && (this.query.search || this.query.q)){
      staticSearchOnOpen = this.query.search || this.query.q;
      staticSearchOnOpen = decodeURI(staticSearchOnOpen);
    }

    //BookshelfController.directToNative(isbn, method, initialCFI);
    BookshelfController._setup({noGA: true});

    if (!url){
      if (initialCFI){
        if (initialCFI.indexOf("/")!==0){
          initialCFI = "/"+initialCFI;
        }
        Fraction.initialCFI = initialCFI;
      }
    }

    let defaultRoute = `/books/${isbn}/${location.search.replace(/\/$/,"")}`;
    getBookshelfRoot().render(
      BookshelfController._wrapTheme(
        <Fraction.Reader
          key={isbn}
          isbn={isbn}
          url={url}
          initialCFI={initialCFI}
          searchOnOpen={staticSearchOnOpen}
          initialPage={page || 'recent'}
          route={defaultRoute}
        />
      )
    );
    Fraction.Helpers.triggerCFIChange();
  },

  recent: function(isbn){
    BookshelfController.show(isbn, false, ('/books/' + isbn + '/pages/recent'), 'recent', false);
  },

  first: function(isbn){
    BookshelfController.show(isbn, false, ('/books/' + isbn + '/pages/first'), 'first', false);
  },

  universalURL: function(isbn, method, location){
    // BookshelfController.directToNative(isbn, method, location);
    var searchOnOpen;
    if (this.query && this.query.search){
      searchOnOpen = this.query.search;
    }
    if (method.toLowerCase()==="root" && location==="0"){
      BookshelfController.show.call(this, isbn, "", false, false, searchOnOpen);
      return;
    }
    BookshelfController.show.call(this, isbn, location, ("/books/" + isbn + "/" + method + "/" + location), false, searchOnOpen);
    return;
    // probably do more stuff here
  },

  pageNotFound: function(isbn) {
    Fraction.Helpers.Locations.safeRedirect("#/books/"+isbn+"/recent");
    Fraction.Helpers.toast(i18n.t("print.page-not-found"));
  },

  bookNotFound: function() {
    Fraction.Helpers.Locations.safeRedirect("#/books");
    Fraction.Helpers.toast(i18n.t("library.book-not-found"));
  },

  signin: function(status, email){
    if (Fraction.Brand.Signin.redirect){
      Fraction.Helpers.Locations.safeRedirect(Fraction.Brand.Signin.redirect);
    } else {
      BookshelfController._setup(this.query);
      document.title += ": "+i18n.t("signin.signin-button");
      var captcha = Fraction.Helpers.getParameterByName('captcha');
      getBookshelfRoot().render(
        BookshelfController._wrapTheme(
          <Fraction.UserPage page="signin" status={status} email={email} captcha={captcha} />
        )
      );
    }
  },

  autoRedeem: function(code){
    Jigsaw.User.redeemCode(code, function(response){
      if (response.isSuccess()){
        Fraction.Router.setRoute("/");
        if (response.data.books.length > 1){
          Fraction.Helpers.toast(i18n.t('redeem.multi-redeem', {count: response.data.books.length}));
        } else {
          var book = response.data.books[0];
          Fraction.Helpers.toast(i18n.t('redeem.single-redeem', {title: book.title, url: ('/#/books/'+book.isbn+"/")}));
        }
      } else if (response.data.code === 401){
        Fraction.Helpers.signin();
      } else {
        Fraction.Router.setRoute("/");
        Fraction.Helpers.toast(i18n.t("redeem.error"));
      }
    });
  },

  autoSubscribe: function(email){
    var decodedEmail = decodeURIComponent(email),
    placeholder = "@placeholder";
    Jigsaw.User.subscribeTo(decodedEmail, function(response){
      if (response.isSuccess()){
        Fraction.Router.setRoute("/");
        if (decodedEmail.includes(placeholder)){
          Fraction.Helpers.toast(i18n.t("subscribe.reference"), {timeout: 5000});
        } else {
          Fraction.Helpers.toast(i18n.t("subscribe.success", {email: decodedEmail}), {timeout: 5000});
        }
      } else if (response.data.code === 401){
        Fraction.Helpers.signin();
      } else {
        Fraction.Router.setRoute("/");
        Fraction.Helpers.toast(i18n.t("subscribe.failure", {email: decodedEmail}), {timeout: 5000});
      }
    });
  },

  userDecide: function(){
    if (this.query && this.query.after){
      Fraction.Helpers.storeRedirect(this.query.after);
    }
    Fraction.Brand.AccountCompletion.force = true;
    getBookshelfRoot().render(
      BookshelfController._wrapTheme(<Fraction.UserPage page="sso" />)
    );
  },

  userComplete: function(){
    BookshelfController._setup();
    if (this.query && this.query.after){
      Fraction.Helpers.storeRedirect(this.query.after);
    }

    Fraction.Helpers.getUser(function(){
      getBookshelfRoot().render(
        BookshelfController._wrapTheme(
          <Fraction.UserPage page="registration"
                             completeAccount={true}
                             email={Fraction.User.email}
                             emailStatus="available" />
        )
      );
    });
  },

  sso: function(){
    document.title += ": "+i18n.t("signin.signin-button");

    if (this.query && this.query.after){
      Fraction.Helpers.storeRedirect(this.query.after);
    }

    Fraction.Helpers.clearStoredBookList();
    Fraction.Helpers.getUser(function(){
      Fraction.Helpers.saveUserData('lastEmailHash', Fraction.User.email.hashMe());
      Fraction.Helpers.saveUserData('lastSessionId', Fraction.User.sessionId);
      Fraction.Helpers.saveUserData('ssoTimeout', Date.now()+86400000); // set 24 hrs out
    });
    getBookshelfRoot().render(
      BookshelfController._wrapTheme(<Fraction.UserPage page="sso" />)
    );
  },

  terms: function(){
    if (this.query && this.query.after_eula){
      Fraction.Helpers.storeRedirect(this.query.after_eula);
    }
    document.title += ": "+i18n.t("sso.terms-and-privacy");
    getBookshelfRoot().render(
      BookshelfController._wrapTheme(<Fraction.UserPage page="terms" />)
    );
  },

  registration: function(status){
    if (this.query && this.query.after){
      Fraction.registrationRedirect = [this.query.after];
    }
    BookshelfController._setup(this.query);
    document.title += ": "+i18n.t('registration.registration');
    Fraction.Router.setRoute('user/registration', true);

    getBookshelfRoot().render(
      BookshelfController._wrapTheme(<Fraction.UserPage page="registration" />)
    );
  },

  updatePassword: function(status){
    BookshelfController._setup(this.query);
    document.title += ": "+i18n.t('registration.registration');
    Fraction.Router.setRoute('user/update-password', true);

    getBookshelfRoot().render(
      BookshelfController._wrapTheme(<Fraction.UserPage page="update-password" />)
    );
  },

  forgot: function(status){
    var forgotURLToken = null;
    if (this.query && this.query.token){
      forgotURLToken = this.query.token;
      //console.log(this.query.token); remove this log, it's just for examples
    }
    BookshelfController._setup(this.query);
    document.title += ": "+i18n.t('signin.forgot-password');
    getBookshelfRoot().render(
      BookshelfController._wrapTheme(<Fraction.UserPage page="forgot" forgotURLToken={forgotURLToken} />)
    );
  },

  activation: function(status){
    // TODO activation
    document.title += ": "+i18n.t('signin.forgot-password');
    getBookshelfRoot().render(
      BookshelfController._wrapTheme(<Fraction.UserPage page="activation" />)
    );
  },

  redirect: function(redirectUrl){
    BookshelfController._setup({noGA: true, skipAuth: true});
    getBookshelfRoot().render(
      BookshelfController._wrapTheme(
        <Fraction.Redirect
          url={decodeURIComponent(redirectUrl)}
          sso={this.query && this.query.sso}
          lti={this.query && this.query.lti}
          type={this.query && this.query.type}
          isbn={this.query && this.query.isbn}
          label={this.query && this.query.label}
          roles={this.query && this.query.roles}
          old={this.query && this.query.old}
          allQueries={this.query}
        />
      )
    );
  },

  newRouter: function(condition, controller) {
    return function() {
      if ((!condition && !controller) || (Fraction.Brand && Fraction.Brand.Redesign && Fraction.Brand.Redesign[condition].enabled)) {
        getBookshelfRoot().render(
          <Fraction.App />
        );
      } else {
        controller.apply(this, arguments)
      }
    }
  },

  cookieError: function(){
    BookshelfController.systemError("cookie");
  },

  systemError: function(errorCode){
    if (!errorCode){
      errorCode = 500;
    } else if (!isNaN(errorCode)) {
      // If not isNaN, we're dealing with a digit, so convert to int
      errorCode = parseInt(errorCode, 10);
    }
    if (errorCode===401){
      Fraction.Helpers.signin();
      return;
    }

    // Don't need authentication for error messages
    BookshelfController._setup({skipAuth: true});

    getBookshelfRoot().render(
      BookshelfController._wrapTheme(<Fraction.Error errorCode={errorCode} />)
    );
  },

  returnToOnline: function(env){
    BookshelfController._setup({skipAuth: true});
    var dest = Fraction.Environment.oldOnlineHost+'/beta/return_from_beta';
    Fraction.Helpers.ssoToOldOnlineURL(dest, false);
    getBookshelfRoot().render(
      BookshelfController._wrapTheme(<Fraction.Loading/>)
    );
  },

  printOnDemand: function(){
    Jigsaw.User.printOnDemandURL(function(resp){
      if (resp.isSuccess()){
        Fraction.Helpers.Locations.safeRedirect(resp.data.url);
      } else if (resp.code===401){
        Fraction.Router.setRoute('/');
      } else {
        BookshelfController.systemError("404");
      }
    });
  },

  directToNative: function(isbn, method, location){
    switch(method){
      case "id": // vbk://[VBID]#[IDENTIFIER]
        window.location = "vbk://" + isbn + "#" + location;
        break;
      case "outline": // vbk://[VBID]#outline([outline number])
        window.location = "vbk://" + isbn + "#outline("+ location + ")";
        break;
      case "page": // vbk://[VBID]#page([PAGE])
        window.location = "vbk://" + isbn + "#page("+ location + ")";
        break;
      case "pageid": // vbk://[VBID]#pageid([PAGE ID])
        window.location = "vbk://" + isbn + "#pageid("+ location + ")";
        break;
      case "epubcfi": // vbk://[VBID]/epubcfi[EPUBCFI]
        window.location = "vbk://" + isbn + "/epubcfi"+ location;
        break;
    }
  },

  oneNoteRedirect: function() {
    getBookshelfRoot().render(
      BookshelfController._wrapTheme(<Fraction.OneNoteRedirect />)
    );
  },

};

var FractionRouter = new DirectorRouter({
  '/legacy-library'                   : BookshelfController.index,
  '/'                                 : BookshelfController.newRouter("Library", BookshelfController.index),
  '/terms'                            : BookshelfController.newRouter("Signin", BookshelfController.terms),
  '/redirect/(.*)'                    : BookshelfController.redirect,
  '/home/eula'                        : BookshelfController.newRouter("Signin", BookshelfController.terms),
  '/home/redeem/:code'                : BookshelfController.autoRedeem,
  '/home/subscribe/(.*)'              : BookshelfController.autoSubscribe,
  '/books.?'                          : BookshelfController.newRouter("Library", BookshelfController.index),
  '/books/bookshelf'                  : BookshelfController.newRouter("Library", BookshelfController.index), // library search "universal url"
  '/user/signin/:status/(.*)'         : BookshelfController.newRouter("Signin", BookshelfController.signin),
  '/user/signin.?'                    : BookshelfController.newRouter("Signin", BookshelfController.signin),
  '/user/signin'                      : BookshelfController.newRouter("Signin", BookshelfController.signin),
  '/user/sso'                         : BookshelfController.newRouter("Signin", BookshelfController.sso),
  '/user/decide'                      : BookshelfController.newRouter("Signin", BookshelfController.userDecide),
  '/user/complete'                    : BookshelfController.newRouter("Signin", BookshelfController.userComplete),
  '/user/edit'                        : BookshelfController.newRouter("Signin", BookshelfController.userComplete),
  '/user/registration'                : BookshelfController.newRouter("Signin", BookshelfController.registration),
  '/user/new'                         : BookshelfController.newRouter("Signin", BookshelfController.registration),
  '/user/registration/new'            : BookshelfController.newRouter("Signin", BookshelfController.registration),
  '/user/update-password'             : BookshelfController.newRouter("Signin", BookshelfController.updatePassword),
  '/activation'                       : BookshelfController.newRouter("Signin", BookshelfController.activation),
  '/forgot'                           : BookshelfController.newRouter("Signin", BookshelfController.forgot),
  '/user/forgot'                      : BookshelfController.newRouter("Signin", BookshelfController.forgot),
  '/books/:isbn'                      : BookshelfController.show, // vbk://[isbn]
  '/books/:isbn/cfi/(.*)'             : BookshelfController.show,
  '/books/:isbn/recent'               : BookshelfController.recent,
  '/books/:isbn/first'                : BookshelfController.first,
  '/books/:isbn/?'                    : BookshelfController.show,
  // causing to match multiple times - '/books/:isbn?q=(.*)'               : BookshelfController.show, // vbk://[VBID]?q=[SEARCH TERMS]
  '/books/:isbn/:method/(.*)'         : BookshelfController.universalURL,
  '/books/:isbn/(.*)'                 : BookshelfController.pageNotFound,
  '/books!(.*)'                       : BookshelfController.bookNotFound,
  '/books/!(.*)'                      : BookshelfController.bookNotFound,
  '/system-error'                     : BookshelfController.systemError,
  '/system-error/:code'               : BookshelfController.systemError,
  '/cookie-error'                     : BookshelfController.cookieError,
  '/return-to-online/:env'            : BookshelfController.returnToOnline,
  '/print-on-demand'                  : BookshelfController.printOnDemand,
  '/onenote'                          : BookshelfController.oneNoteRedirect,
  '/activate/:isbn'                   : BookshelfController.newRouter()
});

FractionRouter.path('/overleaf', Overleaf);
FractionRouter.path('/flashcards', Overleaf);
FractionRouter.on('.*', BookshelfController.newRouter("Library", BookshelfController.index));

$(async function(){
  if (Fraction.Helpers.getCookie("productionJigsaw")==="true"){
    var script = document.createElement("script");
    script.src = "//jigsaw.vitalsource.com/assets/v1/jigsaw/box.js";
    script.type = "text/javascript";
    document.getElementsByTagName("head")[0].appendChild(script);
    window.pointingAtProd = true;
    var prodRedirect = document.location.protocol+"//"+document.location.host+document.location.search;
    var resetProd = $("<button class='prodenv-reset'>Reset</button>");
    resetProd.click(function(){
      Fraction.Helpers.setCookie("productionJigsaw", "");
      Fraction.Helpers.clearStoredBookList();
      window.location.reload();
    });
    $("body").append($("<div class='prodenv'>Running in Production Environment</div>"));
    $(".prodenv").after(resetProd);
  }

  var brand = window.location.hostname;
  //brand = brand.replace('-dev', '').replace("-staging", '');
  var param_brand = Fraction.Helpers.getParameterByName('brand');
  if (param_brand.length>0){ brand=param_brand; }

  // throw in some brand url finding here :)
  var externalRemoveThisVariable = false;
  await window.brands.init('/brands/', brand, externalRemoveThisVariable);
  if (Fraction.Brand.jigsawHost){
    Jigsaw.host = Fraction.Brand.jigsawHost;
  }

  const updateLocale = (locale) => {
    Fraction.Helpers.changeLocale(locale, function () {
      // Load data before rendering anything
      Fraction.Helpers.getUser(function () {
        Fraction.Helpers.loadPersist();
        FractionRouter.init('/');
        $('body').attr('data-theme-base', Fraction.Brand.Theme.base);
        $('body').attr('data-theme-primary', Fraction.Brand.Theme.primary);
        $('body').attr('data-theme-secondary', Fraction.Brand.Theme.secondary);
        Fraction.Reporter.init();
        Fraction.Helpers.refrainFromIframe();
      }, { skipAuth: true });
    });
  };

  // AutoDetect User Language
  if (Fraction.Brand.locale === 'en' || !Fraction.Brand.locale) {
    Jigsaw.User.getPreferredLanguages(response => {
      if (response.isSuccess() && Array.isArray(response.data)) {
        let locale = null;
        do {
          locale = Fraction.Helpers.Locale.getLanguage(response.data.shift());
        } while (!locale && response.data.length > 0);
        locale = locale || 'en';

        updateLocale(locale);
      } else {
        updateLocale(Fraction.Brand.locale);
      }
    });
  } else {
    updateLocale(Fraction.Brand.locale);
  }
});

module.exports = FractionRouter;
